import React, {useState, useContext} from 'react';
import {Container, Row, Col, Button, Form, Spinner, Alert } from 'react-bootstrap';
import axios from "axios";
import $ from 'jquery';
import 'jquery-confirm';
import { AppContext } from '../App';


export const Authentication=()=>{
	const { setAccessToken, link, setUser } = useContext(AppContext);
	const [ loginError, setLoginError ] = useState(false);
	const [ load, setLoad ] = useState(false);
	const AuthCheck=(token)=>{
		axios.get(`${link}api/ss/auth/check/`,{
			headers:{
              Authorization: 'Bearer '+token
            }
		}).then(response=>{
			setLoad(false);
			setUser(response.data);
			setAccessToken(token);
		}).catch(err=>{
			setLoad(false);
			setLoginError(true);
	   		setTimeout(()=>{setLoginError(false)},5000);
	   		setAccessToken();
	   		if (err!==undefined) {
				if(err.response.status === 401){
			        console.log('Auth_check - ',err.response.status,':',err.response.statusText);
			    }else if(err.response.status === 404){
			        console.log('Auth_check - ',err.response.status,':',err.response.statusText);
			    }else if(err.response.status === 500){
			        console.log('Auth_check - ',err.response.status,':',err.response.statusText);
			    }else{
			        console.log('Auth_check - ',err.response.status,':',err.response.data);
			    }
			}else{
		        $.dialog({
		          title: "Can't reach server!",
		          content: 'Please check internet connection!',
		        });
		    }
		});
  	}
	const requestUser=(event)=>{
		setLoad(true);
		event.preventDefault();
		if (event.target.username.value!==""&&event.target.password.value!=="") {
		axios.post(`${link}api/token/`,{
	   		username : event.target.username.value,
	   		password : event.target.password.value,
	   	}).then(function(response){
	   		if(response.status === 200){
	   			AuthCheck(response.data.access);	   			
	   		}else{
	   			setLoad(false);
	   			setLoginError(true);
	   			setTimeout(()=>{setLoginError(false)},5000);
	   		}
	   	}).catch(function (err){
	   		setLoad(false);
	   		setLoginError(true);
	   		setTimeout(()=>{setLoginError(false)},5000);
	   		if (err!==undefined) {
	   			console.log('Invalid credentials!');
	   		}else{
		        $.dialog({
		          title: "Can't reach server!",
		          content: 'Please check internet connection!',
		        });
		      }
	   	});
		}
	}


	return (
		<Container className="wrapper" >
			<Row className="login-window br-4" >
				<div className="p-5 grid-center" >
					{
						loginError!==undefined&&loginError?(
							<Alert variant="warning" className="t-red br-3" >Invalid credentials!</Alert>
						):''
					}
					<Form onSubmit={requestUser} className="login-form" >
				      <Form.Group className="mb-3 text-white">
				        <Form.Control type="text" name="username" required className="shadow-none" placeholder="Username" />
				      </Form.Group>
				      <Form.Group className="mb-3  text-white">
				        <Form.Control type="password" name="password" required className="shadow-none"  placeholder="Password" />
				      </Form.Group>
				      <div className="d-grid gap-2">
				      {
				      	load?(
					      	<Button variant="outline-primary" disabled>
					      	 <span><Spinner animation="border" size="sm" /> Please wait...</span></Button>
					      ):(
					      	<Button type="submit" className="login-btn" >LOGIN</Button>
					      )
					  }
					  </div>
			    	</Form>
				</div>
			</Row>
		</Container>
		);
}